/**
 * @generated SignedSource<<7625c1fe336dcfe06fb06377a5ee7873>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LogoSessionInfo$data = {
  readonly tenant: {
    readonly icon: {
      readonly url: URIString;
    } | null;
    readonly name: string;
  } | null;
  readonly " $fragmentType": "LogoSessionInfo";
};
export type LogoSessionInfo$key = {
  readonly " $data"?: LogoSessionInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"LogoSessionInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LogoSessionInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Tenant",
      "kind": "LinkedField",
      "name": "tenant",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TenantIcon",
          "kind": "LinkedField",
          "name": "icon",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SessionInfo",
  "abstractKey": null
};

(node as any).hash = "2e71c899b5a2092b294702a0ffcefcd1";

export default node;
